import * as React from "react";
const SvgBabyCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 12, viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 1L4 11L1 8", stroke: "#3D4C66", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgBabyCheckmark;
